import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <section className="w-10/12 md:max-w-xl xl:max-w-screen-xl px-6 py-6 flex justify-center items-center bg-gradient shadow-lg">
      <div className="hidden xl:grid grid-cols-4 gap-4">
        <div className="flex items-center justify-center flex-col">
          <img
            src="/Daniele_gentile.png"
            alt="Daniele_gentile"
            className="min-w-[250px] h-full object-cover"
          />
          <p className="py-2 font-semibold">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/danielegentile"
              className="hover:underline"
            >
              @DANIELEGENTILE
            </a>
          </p>
        </div>
        <div className="col-span-2 flex- flex-col justify-center h-full">
          <p className="text-left">
            <span className="tracking-widest">NOB</span>
            {t("about.description")}
          </p>
        </div>
        <div className="flex items-center justify-center flex-col">
          <img
            src="/Alessandro_Marra.png"
            alt="Alessandro_Marra"
            className="min-w-[250px] h-full object-cover"
          />
          <p className="py-2 font-semibold">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/marrabarber"
              className="hover:underline"
            >
              @MARRABARBER
            </a>
          </p>
        </div>
      </div>

      <div className="xl:hidden grid grid-cols-2 gap-0 gap-y-4 text-center text-sm font-bold tracking-normal">
        <div className="flex items-center justify-center flex-col text-xs">
          <img
            src="/Daniele_gentile.png"
            alt="Daniele_gentile"
            className="w-full h-full object-cover"
          />
          <p className="py-1">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/danielegentile"
              className="hover:underline"
            >
              @DANIELEGENTILE
            </a>
          </p>
        </div>
        <div className="flex items-center justify-center flex-col text-xs">
          <img
            src="/Alessandro_Marra.png"
            alt="Alessandro_Marra"
            className="w-full h-full object-cover"
          />
          <p className="py-1">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/marrabarber"
              className="hover:underline"
            >
              @MARRABARBER
            </a>
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-left text-sm font-light tracking-widest md:text-lg">
            <span className="tracking-widest">NOB</span>
            {t("about.description")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
